import BaseComponent from '../../../general/js/base-component';
import React from 'react';
import ReactDOM from 'react-dom';
import LotsSearch from './LotsSearch';

export default class LotsSearchComponent extends BaseComponent {
    constructor() {
        super(...arguments);

        if (!this.options.endpointUrl) {
            throw new Error('endpointUrl should be passed via options');
        }

        let {title = null, showPredictive = true} = this.options;
        this.lotSearchOptions = {...this.options, title, showPredictive};
        this.init();
    }

    init() {
        ReactDOM.render(<LotsSearch options={this.lotSearchOptions}/>, this.element);
    }

    onDestroy() {
        ReactDOM.unmountComponentAtNode(this.element);
    }
}



// WEBPACK FOOTER //
// ./app/components/lots-search/js/lots-search.component.js